import { useDisplayAds, initAds, displayAddSlot } from "@/logic/ads";
import React from "react";
import { useLocation } from "react-router-dom";

export function Ad() {
  const route = useLocation();
  const api = useApi();

  React.useEffect(api.refresh, [route.pathname]);

  if(!api.active) {
    return null;
  }

  return <div className="flex flex-row justify-center">
    <div ref={api.init} id='headerSlot'></div>
  </div>
}

function useApi() {
  const active = useDisplayAds();
  const api = React.useMemo(getApi, [active]);
  api.active = active;

  return api;
}

function getApi() {
  let element: HTMLElement;
  let id: string = '';
  let refreshed = false;

  const init = (e: any) => {
    if(!e) return;
    element = e;
    id = element.id;
    initAds();
    if(refreshed) {
      refresh();
    }
  };

  const refresh = () => {
    refreshed = true;
    if(!id) return;
    displayAddSlot(id as any, true);
  }

  return {
    active: false,
    init,
    refresh
  }
}

function inDom(element: HTMLElement): boolean {
  if(!element.parentElement) return false;
  if(element.tagName === 'BODY') return true;
  return inDom(element.parentElement);
}